export type GalleryImage = {
  src: string
  alt: string
}

/** Same order as `gallery.alts` in each locale file (data/copy). */
export const gallerySources: string[] = [
  'https://cdn.magicpatterns.com/uploads/93dcSqnWYjrEAUXZsCbYb9/la_reina_1.png',
  'https://cdn.magicpatterns.com/uploads/tsWvi2uSkw8HDTM7aqP6bn/cortes.png',
  'https://cdn.magicpatterns.com/uploads/6ZQJs3PTLbg6er6H2B5yZ2/la_reina_2.png',
  'https://cdn.magicpatterns.com/uploads/un19AG89VcwZpvipY9yTfA/la_reina_4.png',
  'https://cdn.magicpatterns.com/uploads/gCoyz171s5KB36Rsa5ByGc/la_reina_8.png',
  'https://cdn.magicpatterns.com/uploads/5A8s36oHz9DaD4jbkVXH4Y/servicio_de_color.png',
  'https://cdn.magicpatterns.com/uploads/tMDFRQUp2ApuXzC8qNoQPP/extensiones_y_trenzas.png',
  'https://cdn.magicpatterns.com/uploads/vBRCmSmnTcvtaYoGGvcm91/tratamientos.png',
]
